(function () {
  if (window.__lvSubToggle) return;
  window.__lvSubToggle = true;

  // Pristine fetch via a hidden same-origin iframe. Appstle monkey-patches
  // window.fetch and can inject/override the selling plan on cart writes, so we
  // bypass it to make our /cart/change.js land exactly as sent. about:blank has
  // no base URL, so we pass absolute URLs.
  var _cf = null;
  var _cw = null;
  function cleanFetch(url, opts) {
    try {
      if (!_cf) {
        var f = document.createElement('iframe');
        f.style.display = 'none';
        f.setAttribute('aria-hidden', 'true');
        (document.body || document.documentElement).appendChild(f);
        _cw = f.contentWindow;
        _cf = _cw.fetch;
      }
      var abs = String(url).charAt(0) === '/' ? window.location.origin + url : url;
      return _cf.call(_cw, abs, opts);
    } catch (e) {
      return fetch(url, opts);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('sub-toggle__input')) return;
    var wrap = input.closest('.sub-toggle');
    if (!wrap) return;

    var key = wrap.getAttribute('data-line-key');
    var qty = parseInt(wrap.getAttribute('data-quantity'), 10) || 1;
    var planId = wrap.getAttribute('data-plan-id');
    var subscribe = input.checked;
    input.disabled = true;

    // selling_plan: <id> subscribes the line; null switches it back to one-time.
    var body = {
      id: key,
      quantity: qty,
      selling_plan: subscribe && planId ? Number(planId) : null
    };

    cleanFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function () {
        // On the full /cart page the section doesn't live-repaint reliably, so
        // reload. In the drawer, FoxTheme re-renders in place via cart:refresh
        // (the fresh markup carries the correct toggle state and grouping).
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        // Revert on failure so the UI matches the real cart.
        input.checked = !subscribe;
        input.disabled = false;
      });
  });

  // Group-level delivery-frequency switch: change every line in a subscription
  // bubble to the chosen selling plan. Line keys + quantities are read from the
  // per-line .sub-toggle elements already present in the group.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('cart-group__freq')) return;
    var group = sel.closest('.cart-group--sub');
    if (!group) return;

    var newPlan = Number(sel.value);
    var prev = sel.getAttribute('data-current');
    if (!newPlan || String(newPlan) === String(prev)) return;

    var lines = [];
    group.querySelectorAll('.sub-toggle[data-line-key]').forEach(function (t) {
      lines.push({
        key: t.getAttribute('data-line-key'),
        qty: parseInt(t.getAttribute('data-quantity'), 10) || 1
      });
    });
    if (!lines.length) return;

    sel.disabled = true;

    // Re-plan the lines one at a time (cart writes must be sequential).
    var chain = Promise.resolve();
    lines.forEach(function (ln) {
      chain = chain.then(function () {
        return cleanFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: ln.key, quantity: ln.qty, selling_plan: newPlan })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart change failed');
          return r.json();
        });
      });
    });

    chain
      .then(function () {
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        // Revert the dropdown to the real plan on failure.
        if (prev) sel.value = prev;
        sel.disabled = false;
      });
  });
})();
